export const getPacketDebugString = (packet) => {
  const propsKeysToDebug = ['userId', 'user_id', 'visitorId', 'visitor_id', 'type'];

  let toPrint = [];

  JSON.parse(
    JSON.stringify(packet),
    (key, value) => {
      if (propsKeysToDebug.includes(key)) {
        toPrint.push(`${key}: ${value}`);
      }
    }
  );

  if (toPrint.length > 0) {
    return toPrint.join('; ');
  }

  return '';
};

export const logFormatObject = (obj = {}) => {
  try {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      return `${acc} ${key}: ${value}; `;
    }, '');
  } catch (e) {
    return e.message;
  }
};

export const safeParse = (jsonString) => {
  try {
    return JSON.parse(jsonString);
  } catch (e) {
    return null;
  }
};
